<span
  [innerHtml]="icon | trustContent : 'svg'"
  [ngClass]="{ 'icon-collapsed': rotate }"
  aria-hidden="true"
></span>
